import createDebug from 'debug';

type DiagnosticDebug = typeof createDebug & {biOriginalLog?: typeof createDebug.log};

const diagnosticDebug = createDebug as DiagnosticDebug;
const configuredNamespaces = diagnosticDebug.disable().split(',').filter(Boolean);
const originalLog = diagnosticDebug.biOriginalLog ?? diagnosticDebug.log;
diagnosticDebug.biOriginalLog = originalLog;

diagnosticDebug.log = function (this: {namespace?: string}, ...args: any[]) {
  const namespace = this.namespace ?? '';
  if (namespace.endsWith(':error')) {
    //                                       
    console.error.apply(console, args);
  } else if (namespace.endsWith(':log')) {
    //                                       
    console.log.apply(console, args);
  } else if (namespace.endsWith(':warn')) {
    //                                       
    console.warn.apply(console, args);
  } else {
    originalLog.apply(this, args);
  }
};

diagnosticDebug.enable([...new Set([...configuredNamespaces, 'bi:*'])].join(','));
(window as any).debug = diagnosticDebug;
